/* GET LEAD NOTES*/
export const GET_LEAD_NOTES = "GET_LEAD_NOTES"
export const GET_LEAD_NOTES_SUCCESS = "GET_LEAD_NOTES_SUCCESS"
export const GET_LEAD_NOTES_ERROR = "GET_LEAD_NOTES_ERROR"

/*CREATE LEAD NOTES*/
export const CREATE_LEAD_NOTES = "CREATE_LEAD_NOTES"
export const CREATE_LEAD_NOTES_SUCCESS = "CREATE_LEAD_NOTES_SUCCESS"
export const CREATE_LEAD_NOTES_ERROR = "CREATE_LEAD_NOTES_ERROR"

/*UPDATE LEAD NOTES*/
export const UPDATE_LEAD_NOTES = "UPDATE_LEAD_NOTES"
export const UPDATE_LEAD_NOTES_SUCCESS = "UPDATE_LEAD_NOTES_SUCCESS"
export const UPDATE_LEAD_NOTES_ERROR = "UPDATE_LEAD_NOTES_ERROR"

/*DELETE LEAD NOTES */
export const DELETE_LEAD_NOTES = "DELETE_LEAD_NOTES"
export const DELETE_LEAD_NOTES_SUCCESS = "DELETE_LEAD_NOTES_SUCCESS"
export const DELETE_LEAD_NOTES_ERROR = "DELETE_LEAD_NOTES_ERROR"

/* GET CALL NOTES*/
export const GET_CALL_NOTES = "GET_CALL_NOTES"
export const GET_CALL_NOTES_SUCCESS = "GET_CALL_NOTES_SUCCESS"
export const GET_CALL_NOTES_ERROR = "GET_CALL_NOTES_ERROR"

/*CREATE CALL NOTES*/
export const CREATE_CALL_NOTES = "CREATE_CALL_NOTES"
export const CREATE_CALL_NOTES_SUCCESS = "CREATE_CALL_NOTES_SUCCESS"
export const CREATE_CALL_NOTES_ERROR = "CREATE_CALL_NOTES_ERROR"

/*UPDATE CALL NOTES*/
export const UPDATE_CALL_NOTES = "UPDATE_CALL_NOTES"
export const UPDATE_CALL_NOTES_SUCCESS = "UPDATE_CALL_NOTES_SUCCESS"
export const UPDATE_CALL_NOTES_ERROR = "UPDATE_CALL_NOTES_ERROR"

/*DELETE CALL NOTES */
export const DELETE_CALL_NOTES = "DELETE_CALL_NOTES"
export const DELETE_CALL_NOTES_SUCCESS = "DELETE_CALL_NOTES_SUCCESS"
export const DELETE_CALL_NOTES_ERROR = "DELETE_CALL_NOTES_ERROR"

